import type { EnvironmentConfig } from './interfaces.js';

const digitalEdge = 'https://p-gsg.digitaledge.cigna.com';

export const environment: EnvironmentConfig = {
  i18n: {
    fallbackLng: 'en-us',
    load: 'currentOnly',
    lowerCaseLng: true,
    ns: [],
    supportedLngs: ['en-us', 'es-us'],
    backend: {
      loadPath: (lngs: string | string[], _namespaces: string | string[]) =>
        lngs === 'en-us'
          ? '/static/www-cigna-com/json/{{- ns}}.json'
          : '/static/www-cigna-com/{{lng}}/json/{{- ns}}.json',
    },
    detection: {
      order: ['htmlTag'],
    },
  },
  endpoints: {
    campaigns: `${digitalEdge}/webservices/common/v1/campaigns`,
    relatedLinks: `${digitalEdge}/webservices/common/v1/related-links`,
    medicarePlanFinder: `${digitalEdge}/igse/connecturedrx2`,
    igse: 'https://plans.cigna.com',
    zipSegment: '/static/www-cigna-com/json/ifp-eop-zip-segment.json',
  },
  flags: {
    enableEloquaTestEmails: false,
  },
};
